import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import { ILibName, Header as LibraryHeader, getSurnameWithInitials } from '@infologistics/frontend-libraries'

import Buttons from './components/Buttons'
import Logo from './components/Logo'
import Organizations from './components/Organizations'
import { IApplicationState } from '@store/types/commonTypes'
import { IUserState } from '@store/modules/user/types'
import { useTranslation } from 'react-i18next'

const Header: FC = () => {
  const user: IUserState  = useSelector((state: IApplicationState) => state.user);
  const classInfo = 'd-flex align-items-center ml-auto mr-3 text-muted-600 mb-0 fw-400';
  const { i18n: { language } } = useTranslation();

  const fullUser: ILibName = {
    ...user,
    language: language,
  }

  return (
    <LibraryHeader>
      <Logo />

      <Organizations />

      <div className={classInfo}>
        <span className='mr-4'>{getSurnameWithInitials(fullUser)}</span>
        <Buttons />
      </div>
    </LibraryHeader>
  )
}

export default Header
